import { Icon, IconButton } from "@material-ui/core";
import {
  PrinterStore,
  usePrinterStore,
} from "application/contexts/printer/PrinterStore";
import { EletronicInvoiceTicket } from "domains/order/agreggates/EletronicInvoiceTicket/EletronicInvoiceTicket";
import { CreatePrintNfceUseCase } from "modules/order/application/useCases/CreatePrintNfceUseCase";
import moment from "moment";
import React, { FC, useCallback, useMemo, useState } from "react";
import { useShallow } from "zustand/react/shallow";
import { useAdmin } from "../../../../application/contexts/admin/adminContext";
import { OrderLog } from "../../../../domains/order/agreggates/order/Order";
import { TransactionTypeLabel } from "../../../../domains/order/agreggates/payment/transactionType";
import styles from "./OrderLogItemPreview.module.scss";
import { moneyMask } from "utils/utils";
import { ProdutoTipo } from "Infrastructure/interfaces/PedidoMeep";
import OrderListProducts from "./orderListProducts.tsx/OrderListProducts";

interface OrderListProps {
  orderLog: OrderLog;
  defaultShowLogs?: boolean;
}

export const OrderList: FC<OrderListProps> = ({ orderLog, defaultShowLogs = false }) => {
  const { verifyRoles } = useAdmin();
  const [showLogs, setShowLogs] = useState(defaultShowLogs);

  const [addOrdersToPrintQueue] = usePrinterStore(
    useShallow((state: PrinterStore) => [state.addOrders])
  );

  const onClickPrint = useCallback(
    (nf: EletronicInvoiceTicket[]) => {
      addOrdersToPrintQueue(CreatePrintNfceUseCase(nf));
    },
    [addOrdersToPrintQueue]
  );

  const nfs = useMemo(() => {
    return orderLog.nfce?.filter((it) => it.danfe);
  }, [orderLog.nfce]);

  const ticketsCount = useMemo(
    () =>
      orderLog.orderItems
        .filter((item) => item.productType !== ProdutoTipo.TaxaServico)
        .reduce((acc, it) => (acc += it.ticketIds?.length ?? 0), 0),
    [orderLog.orderItems]
  );

  return (
    <div id={styles.OrderLogItemPreview}>
      <div className={styles.orderDetail}>
        <div>
          Pedido: <span>{orderLog.friendlyId}</span>
        </div>
        <div>
          Status:
          <span
            style={{ color: orderLog.paymentApproved ? "#399C54" : undefined }}
          >
            {orderLog.paymentApproved ? "Pagamento aprovado" : "Não finalizado"}
          </span>
        </div>
        <div>
          Id: <span>{orderLog.id}</span>
        </div>
        <div>
          Horario:
          <span>
            {moment(orderLog.createdAt).format("DD/MM/YYYY [as] HH:mm:ss")}
          </span>
        </div>
        <div>
          Quantidade:
          <span>{ticketsCount ? ticketsCount : 1}</span>
        </div>
        <div>
          Valor total:
          <span>{moneyMask(orderLog.totalValue)}</span>
        </div>
        {orderLog?.payment && (
          <div>
            Forma de pagamento:
            <span>
              {TransactionTypeLabel.get(orderLog.payment?.paymentMethod)}
            </span>
          </div>
        )}
        {orderLog?.payment?.cardNumber && (
          <div>
            Cartão: <span>{orderLog.payment.cardNumber}</span>
          </div>
        )}
      </div>
      <div className={styles.products}>
        <OrderListProducts order={orderLog} />
      </div>
      <div className={styles.logs}>
        <div>
          Logs
          <IconButton onClick={() => setShowLogs((prev) => !prev)}>
            <Icon>
              {showLogs ? "keyboard_arrow_up" : "keyboard_arrow_down"}
            </Icon>
          </IconButton>
        </div>
        {showLogs && (
          <div className={styles.logContainer}>
            {orderLog?.log
              ?.sort(
                (a, b) =>
                  new Date(b.time).getTime() - new Date(a.time).getTime()
              )
              .map((it, key) => (
                <div className={styles.logItem} key={key}>{`${moment(
                  it.time
                ).format("DD/MM/YYYY [-] HH:mm:ss")}: ${it.message}`}</div>
              ))}
            {verifyRoles("ReimpressaoTicketTotem") && nfs?.length && (
              <div
                className={styles.nf}
                onClick={() => onClickPrint(orderLog.nfce!)}
              >
                Reimprimir Nota Fiscal
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
